import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from "vuex-map-fields";
import * as _ from 'lodash';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_DEGREE,
  DELETE_DEGREE,
  GET_DEGREES,
  GET_DEGREE,
  UPDATE_DEGREE,
} from '@/queries/modules/common-data/degree';

//
// initial state
const state = {
  degree: {
    id: "",
    code: "",
    nameLocal: "",
    nameEng: "",
  },
  degrees: [],
  searchDegreeResults: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setDegrees: (state, payload) => {
    state.degrees = payload ? payload : [];
    state.searchDegreeResults = payload ? payload : [];
  },
  setDegree: (state, payload) => {
    state.degree = payload;
  },
  setSelectedDegree: (state, payload) => {
    state.degree = {...payload};
  },
  setSearchDegreeResults: (state, payload) => {
    state.searchDegreeResults = payload;
  },
  clearSelectedDegree: (state) => {
    state.degree = {
      id: "",
      code: "",
      nameLocal: "",
      nameEng: "",
    }
  }
};

//
// actions
const actions = {
  getDegrees: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_DEGREES,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setDegrees', data.getDegrees);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getDegree: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_DEGREE,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setDegree', data.getDegree);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  searchDegrees: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      commit('setSearchDegreeResults', _.filter(state.degrees, (degree) => _.some(degree, value => _.includes(_.toLower(value), _.toLower(payload)))));
      commit('setProcessing', false);
    } catch (err) {
      commit('setError', error(err));
    }
  },
  addDegree: async ({commit}, payload) => {
    commit('setProcessing', true);

    await apolloClient
      .mutate({
        mutation: ADD_DEGREE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const degrees = [...state.degrees];
        degrees.push(data.addDegree);
        commit('setDegrees', degrees);
        commit('setSuccess', newItemSuccess(data.addDegree.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateDegree: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_DEGREE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.degrees.findIndex(degree => degree.id === data.updateDegree.id);
        const degrees = [
          ...state.degrees.slice(0, index),
          data.updateDegree,
          ...state.degrees.slice(index + 1)
        ];

        commit('setDegrees', degrees);
        commit('setSuccess', updateItemSuccess(data.updateDegree.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteDegree: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_DEGREE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.degrees.findIndex(degree => degree.id === data.deleteDegree.id);
        const degrees = [
          ...state.degrees.slice(0, index),
          ...state.degrees.slice(index + 1)
        ];

        commit('setDegrees', degrees);
        commit('setSuccess', deleteItemSuccess(data.deleteDegree.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedDegree: async ({commit}, payload) => {
    commit('setSelectedDegree', payload);
  },
  clearSelectedDegree: async ({commit}) => {
    commit('clearSelectedDegree');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
